import React from 'react';

/**
 * This gives the props to be spread into the div to prevent click propagation
 */
export const getPreventClickPropagationProps = () => ({
    onClick: (ev: React.MouseEvent) => ev?.stopPropagation?.(),
    role: 'none',
});
